import React from "react";
import WarningIcon from '@material-ui/icons/Warning';

const RequestSimilarCount = (cellData) => {
  if (cellData && cellData.value && cellData.value > 0) {
    return (
      <div style={{ color: "#ff9800", display: "flex", padding: "4px", border: "1px solid #ff9800", borderRadius: "4px"}}>
        <WarningIcon fontSize={"small"}/>
        <span style={{marginLeft: "4px", fontWeight: 600, display: "inline", lineHeight: "18px"}}>{cellData.value}</span>
      </div>
    )
  }
}

function requestSimilarCountCell(config) {
  config.cellRender = RequestSimilarCount;
  config.alignment = "left";
}

export {requestSimilarCountCell};
